<template>
    <div class="md-layout md-gutter">
        <div class="md-layout-item">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <div class="card-icon">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'file-contract']" />
                            </div>
                            <h4 class="title">Liste des contrats</h4>
                        </div>
                    </div>
                </md-card-header>
                <md-card-content>
                    <div>
                        <span class="font-bold">Filtres</span>
                    </div>
                    <div class="flex items-center justify-between">
	                    <div class="flex items-center space-x-6">
		                    <div style="min-width: 150px; max-width: 150px;">
			                    <div class="md-multiselect">
				                    <label>Année</label>
				                    <multiselect v-model="filter.year"
				                                 :options="filter.years"
				                                 :show-labels="false"
				                                 :allow-empty="false"
				                                 placeholder="Année"
				                                 label="label"
				                                 track-by="value">
					                    <template slot="noOptions">La liste est vide</template>
					                    <template slot="noResult">Aucun élement correspondant</template>
				                    </multiselect>
			                    </div>
		                    </div>
		                    <div style="min-width: 200px; max-width: 200px;">
			                    <div class="md-multiselect">
				                    <label>Mois</label>
				                    <multiselect v-model="filter.monthStart"
				                                 :options="filter.months"
				                                 :allow-empty="false"
				                                 :show-labels="false"
				                                 placeholder="Mois"
				                                 label="label"
				                                 track-by="value">
					                    <template slot="noOptions">La liste est vide</template>
					                    <template slot="noResult">Aucun élement correspondant</template>
				                    </multiselect>
			                    </div>
		                    </div>
		                    <div style="min-width: 200px; max-width: 200px;">
			                    <div class="md-multiselect">
				                    <label>Mois</label>
				                    <multiselect v-model="filter.monthEnd"
				                                 :options="filter.months"
				                                 :show-labels="false"
				                                 placeholder="Mois"
				                                 label="label"
				                                 track-by="value">
					                    <template slot="noOptions">La liste est vide</template>
					                    <template slot="noResult">Aucun élement correspondant</template>
				                    </multiselect>
			                    </div>
		                    </div>
		                    <div style="min-width: 200px; max-width: 200px;">
			                    <div class="md-multiselect">
				                    <label>État</label>
				                    <multiselect v-model="filter.state"
				                                 :options="filter.states"
				                                 :searchable="false"
				                                 :show-labels="false"
				                                 :allow-empty="false"
				                                 label="label"
				                                 track-by="value">
					                    <template slot="noOptions">La liste est vide</template>
					                    <template slot="noResult">Aucun élement correspondant</template>
				                    </multiselect>
			                    </div>
		                    </div>
		                    <div style="min-width: 200px; max-width: 200px;">
			                    <div class="md-multiselect">
				                    <label>Option</label>
				                    <multiselect v-model="filter.option"
				                                 :options="filter.options"
				                                 :searchable="false"
				                                 :show-labels="false"
				                                 label="label"
				                                 track-by="value"
				                                 placeholder="Échéance / Tacit">
					                    <template slot="noOptions">La liste est vide</template>
					                    <template slot="noResult">Aucun élement correspondant</template>
				                    </multiselect>
			                    </div>
		                    </div>
	                    </div>
	                    <div class="flex items-center space-x-4">
		                    <md-button class="md-success md-icon-button md-raised my-auto" @click="getContracts">
			                    <font-awesome-icon class="md-icon" :icon="['fa', 'filter']" />
			                    <span class="font-medium ml-2 leading-none">Filtrer</span>
		                    </md-button>
		                    <md-button class="md-default md-icon-button md-raised my-auto" @click="resetFilters">
			                    <font-awesome-icon class="md-icon" :icon="['fa', 'times-circle']" />
			                    <span class="font-medium ml-2 leading-none">Réinitialiser</span>
		                    </md-button>
	                    </div>
                    </div>
	                <div class="block-alert warning mb-2" v-if="filter.error">
		                <p class="font-medium">Attention, la date de début est plus grande que la date de fin, changez les mois !</p>
	                </div>
	                <div class="flex items-center justify-between">
		                <div>
			                <span class="font-medium">{{ `Total : ${this.pagination.total} contrats` }}</span>
		                </div>
		                <div style="min-width: 200px;">
			                <div class="md-multiselect">
				                <label>Éléments à afficher</label>
				                <multiselect v-model="pagination.perPage"
				                             :options="pagination.perPageOptions"
				                             :searchable="false"
				                             :show-labels="false"
				                             :allow-empty="false">
					                <template slot="noOptions">La liste est vide</template>
					                <template slot="noResult">Aucun élement correspondant</template>
				                </multiselect>
			                </div>
		                </div>
	                </div>
                    <div class="relative" style="min-height: 250px;">
	                    <md-table :value="contracts" class="paginated-table" table-header-color="blue">
		                    <md-table-row v-if="contracts.length > 0" slot="md-table-row" slot-scope="{ item }">
			                    <md-table-cell md-label="#" style="max-width: 25px;">{{ item.id }}</md-table-cell>
			                    <md-table-cell md-label="Numéro">{{ item.number }}</md-table-cell>
			                    <md-table-cell md-label="Client - Site" style="max-width: 550px; width: 550px;">
				                    <div class="font-medium">{{ item.client_name }}</div>
				                    <div class="text-xs">{{ item.site_name }}</div>
			                    </md-table-cell>
			                    <md-table-cell md-label="État" style="max-width: 25px;">
				                    <div :class="item.is_active ? 'text-success' : 'text-danger'">
					                    <font-awesome-icon class="md-icon" style="min-width: 14px; max-width: 18px;" :icon="['fa', item.is_active ? 'check' : 'times']" />
				                    </div>
			                    </md-table-cell>
			                    <md-table-cell md-label="Informations" style="max-width: 150px; width: 150px;">
				                    <div class="flex flex-col items-start">
					                    <p>Début du contrat le : <span class="font-medium">{{ $moment(item.first_period_date_start).format('DD/MM/YYYY') }}</span></p>
					                    <p v-if="item.last_period_is_canceled" class="text-danger">
						                    Résiliation prévue le : <span class="font-medium">{{ $moment(item.last_period_cancel_date).format('DD/MM/YYYY') }}</span>
					                    </p>
				                    </div>
			                    </md-table-cell>
			                    <md-table-cell md-label="" style="max-width: 75px;">
				                    <div class="w-auto">
					                    <md-button class="md-icon-button md-raised md-warning"
					                               @mousedown="goToRoute($event, 'Contract Details', { contractId: item.id })">
						                    <i class="md-icon fa fa-pen" />
					                    </md-button>
				                    </div>
			                    </md-table-cell>
		                    </md-table-row>
		                    <md-table-empty-state v-if="!loading"
		                                          md-label="Pas de contrats trouvés"
		                                          md-description="Essayez une recherche différente">
		                    </md-table-empty-state>
	                    </md-table>
	                    <div v-if="loading" class="loader-overlay opacity-100 absolute z-50 w-full h-full">
		                    <div class="h-full w-full flex items-center justify-center">
			                    <md-progress-spinner class="md-white" md-mode="indeterminate"
			                                         :md-diameter="50" :md-stroke="4"></md-progress-spinner>
		                    </div>
	                    </div>
                    </div>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <p class="card-category">
                        Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
                    </p>
                    <pagination
                        class="pagination-no-border pagination-info"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total"
                        @input="getContracts">
                    </pagination>
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>

<script>
import { Pagination } from "@/components";

import routerMixin from "../../mixins/router-mixin";

export default {
    name: "Contracts",
    components: {
        Pagination
    },
	mixins: [routerMixin],
    data() {
        return {
            contracts: [],
            filter: {
                years: [],
                year: null,
	            months: [],
                monthStart: null,
                monthEnd: null,
	            states: [],
	            state: null,
	            options: [],
                option: null,
	            isTacit: false,
	            isNotice: false,
	            error: false
            },
            pagination: {
                perPage: 50,
                currentPage: 1,
                perPageOptions: [25, 50, 100],
                total: 0
            },
	        loading: true
        }
    },
    computed: {
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.pagination.total < highBound) {
                highBound = this.pagination.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.contracts.length;
        },
    },
    methods: {
        async getContracts() {
            if(this.filter.monthEnd !== null && this.filter.monthStart.value > this.filter.monthEnd.value) {
                this.filter.error = true
            } else {
				this.filter.error = false
	            this.loading = true

                const response = await this.$store.dispatch('contracts/getContracts', {
                    page: this.pagination.currentPage,
                    perPage: this.pagination.perPage,
                    year: this.filter.year.value,
                    month_start: this.filter.monthStart.value,
                    month_end: this.filter.monthEnd === null ? null : this.filter.monthEnd.value,
                    state: this.filter.state.value,
                    option: this.filter.option?.value,
                })
                this.contracts = response.data.data
                this.pagination.total = response.data.total
	            this.loading = false
            }
        },
	    setupFilter() {
            for(let i = -5; i <= 4; i++) {
                this.filter.years.push({
	                value: (this.$moment().year() + i),
	                label: (this.$moment().year() + i)
                })
            }

			this.filter.months = this.$moment.months().map((month, key) => { return { value: key, label: month.charAt(0).toUpperCase() + month.slice(1) }})
		    this.filter.states = [
			    { value: 'canceled', label: 'Seulement résilié' },
			    { value: 'started', label: 'Seulement débuté' },
		    ]
		    this.filter.options = [
			    { value: 'isNotice', label: 'À échéance' },
			    { value: 'isTacit', label: 'Tacit reconduction' },
		    ]

			this.filter.year = { value: this.$moment().year(), label: this.$moment().year() }
			this.filter.monthStart = this.filter.months[this.$moment().month()]
		    this.filter.state = this.filter.states[0]
        },
	    resetFilters() {
			this.filter.year = { value: this.$moment().year(), label: this.$moment().year() }
		    this.filter.monthStart = this.filter.months[this.$moment().month()]
		    this.filter.monthEnd = null
		    this.filter.state = this.filter.states[0]
		    this.filter.option = null

		    this.getContracts()
	    },
    },
    mounted() {
        this.setupFilter()
        this.getContracts()
    }
}
</script>

<style scoped>

</style>
